import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown, Plus } from "lucide-react";
import { z } from "zod";
import { useState } from "react";
import Paginat from "@/components/lib/paginat";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";
import { useFilter } from "@/hooks/useFilter";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";
import FloorList from "./FloorList";
import AddEditFloor from "./AddEditFloor";
import hasPermission from "@/hooks/hasPermission";

function FloorTable({data, onRefresh }) {
  // const { drinks } = useSelector((state) => state.menuManage.drink);
  const [formType, setFormType] = useState('')
  const [isSingleVoucherModalOpen, setIsSingleVoucherModalOpen] = useState(false);
  const closeSingleVoucher = () => {
    setIsSingleVoucherModalOpen(false); 
    // setItemsDialog(null)
  };
  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const filteredData = useFilter(data?.data?.Floors, filters, {
    delay: 300,
    defaultFilter: (item) => item.status !== "draft" && item.status !== "archived",
  });
  const searchData = useSearch(
    filteredData,
    searchText,
    ["item_no", "name", "description"],
    300
  );
  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent value="floor">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          <div className="w-[260px]">
            <div className="relative">
              {/* <Link to={"/backoffice/menu/drinks/create"}> */}
              {hasPermission("back_office.settings.create_floor") && (
                <Button
                  onClick={() => {
                    setIsSingleVoucherModalOpen(true)
                    setFormType('create')
                  }}
                >
                  <Plus /> Add New Floor
                </Button>
              )}
              {/* </Link> */}
            </div>
          </div>
          <div className="flex flex-col  gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center">
              <div className="relative">
                <Select
                  onValueChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      status: value === "0" ? "" : value,
                    }))
                  }
                >
                  <SelectTrigger className="w-[100px]">
                    <SelectValue placeholder="Status" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="0">All</SelectItem>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="inactive">Archived</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button
                className={"bg-cblack3 border border-gray-600 text-cwhite2"}
              >
                <FileDown /> Export
              </Button>
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  onValueChange={(value) => setPerPage(Number(value))}
                  value={perPage.toString()}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <FloorList data={paginatedData} onRefresh={onRefresh} formType={formType} setFormType={setFormType} />
        </div>
        <AddEditFloor 
          isOpen={isSingleVoucherModalOpen}
          onClose={closeSingleVoucher}
          formType={formType}
          onRefresh={onRefresh}
        />
        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default FloorTable;

const dateSchema = z.object({
  date: z.string().min(1, "Date is required"),
});
